import { translate as $t } from '@wealthbar/i18n';
import { fetchPaymentInfo, updatePaymentInfo } from '@/lib/api';

export default {
  state: {
    paymentInfo: {},
    loading: false,
  },

  getters: {
    paymentInfo(state) {
      return state.paymentInfo;
    },
    isPaymentInfoSet(state) {
      return !!state.paymentInfo.accountNumber && !!state.paymentInfo.transitNumber && !!state.paymentInfo.institutionNumber;
    },
    isLoadingPaymentInfo(state) {
      return state.loading;
    },
  },

  mutations: {
    updatePaymentInfo(state, paymentInfo) {
      state.paymentInfo = paymentInfo;
    },
    setLoaderPaymentInfo(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async fetchPaymentInfo({ commit }) {
      commit('setLoaderPaymentInfo', true);
      const paymentInfo = await fetchPaymentInfo.execute();
      commit('updatePaymentInfo', paymentInfo);
      commit('setLoaderPaymentInfo', false);
      return paymentInfo;
    },

    async fetchPaymentInfoNoLoader({ commit }) {
      const paymentInfo = await fetchPaymentInfo.execute();
      commit('updatePaymentInfo', paymentInfo);
      return paymentInfo;
    },

    async updatePaymentInfo({ commit, dispatch }, paymentInfo) {
      commit('setLoaderPaymentInfo', true);
      const result = await updatePaymentInfo.execute(paymentInfo);
      if (result.success) {
        commit('updatePaymentInfo', paymentInfo);
        dispatch('showNotification', { icon: '/images/flying-money.png', message: $t('Payment info saved.') });
      }
      commit('setLoaderPaymentInfo', false);
      // TO DO: Handle server errors
      // else {
      //   dispatch('showNotification', { icon: '/images/warning.png', message: 'Failed to save due to connection error. Please try saving again.' });
      // }
      return result;
    },
  },
};
